/**
 * Current application version
 */
export const appVersion = "1.2.7";
